import autobind from 'core-decorators/lib/autobind';
import classnames from 'classnames';
import { VODCSSModules } from 'shared/utils/wix-connect';
import { GenericButton } from 'shared/components/button/button';

import ArrowIcon from 'static/images/arrow-right.svg';

import styles from './nav.styl';


@VODCSSModules(styles)
export default class Nav extends React.Component {

  static propTypes = {
    prevButtonClassName: React.PropTypes.string,
    nextButtonClassName: React.PropTypes.string,

    customArrowIcon: React.PropTypes.element,

    isPrevVisible: React.PropTypes.bool,
    isNextVisible: React.PropTypes.bool,
    isDisabled: React.PropTypes.bool,

    onPrevClick: React.PropTypes.func.isRequired,
    onNextClick: React.PropTypes.func.isRequired,

    dataHook: React.PropTypes.string,
  };

  get arrowIcon() {
    const { customArrowIcon } = this.props;
    return customArrowIcon || <ArrowIcon />;
  }

  get prevButton() {
    const { prevButtonClassName } = this.props;

    return (
      <GenericButton onClick={this.handlePrevClick}
                     className={classnames('qa-prev-button', prevButtonClassName)}
                     data-hook="prev-button"
                     styleName="prev-button">
        {this.arrowIcon}
      </GenericButton>
    );
  }

  get nextButton() {
    const { nextButtonClassName } = this.props;

    return (
      <GenericButton onClick={this.handleNextClick}
                     className={classnames('qa-next-button', nextButtonClassName)}
                     data-hook="next-button"
                     styleName="next-button">
        {this.arrowIcon}
      </GenericButton>
    );
  }

  @autobind
  handleNextClick() {
    const { isDisabled, onNextClick } = this.props;
    if (isDisabled) {
      return;
    }
    onNextClick();
  }

  @autobind
  handlePrevClick() {
    const { isDisabled, onPrevClick } = this.props;
    if (isDisabled) {
      return;
    }
    onPrevClick();
  }

  render() {
    const { isPrevVisible, isNextVisible, dataHook } = this.props;

    return (
      <div data-hook={dataHook}>
        {isPrevVisible && this.prevButton}
        {isNextVisible && this.nextButton}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/components/nav/nav.js